import { Col, Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KDatePicker from 'app/components/Modules/Form/KDatePicker'
import KFormList from 'app/components/Modules/Form/KFormList'
import KInputText from 'app/components/Modules/Form/KInputText'
import { convertIsoToString } from 'app/lib/apollo/normalizers/utilities'
import * as React from 'react'

interface Props {
  line_items: ILineItem[]
}

const BulkForm: React.FC<MemberProps<ILineItem, Props>> = ({
  props: { line_items } = { line_items: [] }
}) => {
  const minDate = line_items.sort((a, b) => (a.returnDate > b.returnDate ? -1 : 1))[0]?.returnDate

  return (
    <Row>
      <Col span={24}>
        <KFormList name="lineItemIds">
          {() =>
            line_items.map((line_item, index) => (
              <KInputText
                hidden
                key={line_item.id}
                initialValue={line_item.id.toString()}
                name={[index]}
              />
            ))
          }
        </KFormList>
        <KDatePicker
          disablePast
          labelRenderer={(label) => <span className="font-weight-bold">{label}</span>}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="returnDate"
          minDate={convertIsoToString(minDate)}
          initialValue={convertIsoToString(minDate)}
          showTime={false}
        />
      </Col>
    </Row>
  )
}

export default BulkForm
